import React, { useState, useEffect, useRef, useContext, useCallback } from 'react'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
/* --------------------------------------------- */
import { routeMap, routeVarMap } from '../../route'
/* --------------------------------------------- */
import utils from '../../utils/utils'
import useErrorUtils from '../../utils/useErrorUtils'
import { getAppLanguageWithoutRegion, splitLanguage, getSelectedSubtitleTrack } from '../../utils/localStorageService'
/* --------------------------------------------- */
import { GlobalContext } from '../../context/global.context'
/* --------------------------------------------- */
import useAnalytics from '../../containers/useAnalytics'
import useFavApi from '../../apis/useFavApi'
/* --------------------------------------------- */
import Timer from '.././Timer'//
import ShareOutlineIcon from '.././icons/ShareOutlineIcon'//
// import PlayIcon from '.././icons/PlayIcon'//
import FavOutlineIcon from '.././icons/FavOutlineIcon'//
import CloseIcon from '.././icons/CloseIcon'//
/* --------------------------------------------- */
import useLoggly from '../../containers/useLoggly'
/* --------------------------------------------- */
import FavouritesIcon from '.././icons/FavouritesIcon'//
/* --------------------------------------------- */
import SEOTags from '../../components/SEOTags'
/* --------------------------------------------- */
// import StarFilledIcon from './icons/StarFilledIcon'
import PlayerContainer from '../../containers/PlayerContainer'
import FavMarkedIcon from '.././icons/FavMarkedIcon'//
import DropDownCircle from '.././icons/DropDownCircle'//
import Spinner from '.././Spinner'
import {
  DetailsSectionWrapper, BodyTextSecondary, DetailsPagePopupHeader, DetailsSectionSubtitle,
  DetailsSectionSubtitleMovie, MetaBodyTextPrimaryH2, DetailsSectionTitle, DetailsPageBadges,
  PlayBtnAction, DetailsSectionMetaTitle, MetaBodyTextSecondary, MetaBodyTextTertiary,
  SeasonSelector, MetaBodyTextTertiaryP, DetailsSectionMetaValue, DetailsSectionDescription, DetailsPopup
} from './style'

/* --------------------------------------------- */
// import imdbLogo from '../imgs/imdbLogo.jpeg'
/* --------------------------------------------- */
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton
} from 'react-share'
// import PlayOutlineIconFilled from '.././icons/PlayOutlineIconFilled'
import PlayOutlineIcon from '.././icons/PlayOutlineIcon'
import TwitterIcon from '.././icons/TwitterIcon'
import WarningPopup from '.././WarningPopup'
/* --------------------------------------------- */
// DetailsSection components which handles movies, series, channel, sports metadata.
const DetailsSection = ({
  detailsSectionData, thisIsChannel, url, title, subTitle, details, description, timeLeft, mediaId, catalogFeature = {},
  seasonId, trailers, movieSeriesId, episodeNumber, seasonNumber, castConfigPlaybackFormat, isLivePlayer,
  isShowFavourites, isSportingEvent, seasonData, curentSeason, type, appMessages, previewAssetFormat,
  theme, images, handleCurrentSeasonChange, metaTheme, baseUrl, releaseYear, dataLoading, progress: progressProp, duration: durationProp, isPurchasedProduct,
  isCcAvailable, isHdAvailable, parentalControl, displayDuration, contentGuid, contentOfferId, purchaseMode, percentComplete,
  isProductLoading, episodeTitle, identityProvider, streams, pageName, mediaInfo = {}
}) => {
  console.log('## is liv player details', isLivePlayer, type)
  const isLive = moment().isAfter(utils.convertUTCtoRelativeTimezone(timeLeft))
  const [isFavourite, updateIsFavourite] = useState(false)
  const [isSeasonPopup, updateIsSeasonPopup] = useState(false)
  const [descriptionData, updateDescriptionData] = useState(description)
  const [isMediaDeatilsPopup, updateIsMediaDeatilsPopup] = useState(false)
  const [activeSeason, updateActiveSeason] = useState({})
  const [progress, setProgress] = useState(progressProp)
  const [duration, updateDuration] = useState(null)
  const [playerUrl, setPlayerUrl] = useState(url)
  const [currentTrailer, updateCurrentTrailer] = useState(null)
  const [isShowFavouriteIcon, setIsShowFavouriteIcon] = useState(false)
  const [sharePopUp, UpdateSharePopUp] = useState(false)
  const [isFavouriteRunning] = useState(false)
  const [isShowWaringPopup, updateIsShowWaringPopup] = useState(false)
  const [shareUrl, setShareUrl] = useState('')
  const [jsonLD, setJsonLD] = useState({})
  const [currentPosterImage, setCurrentPosterImage] = useState(images)
  /* --------------------------------------------- */
  const history = useHistory()
  const location = useLocation()
  const params = useParams()
  /* --------------------------------------------- */
  const { showError, hideAllErrors } = useErrorUtils()
  /* --------------------------------------------- */
  const { log } = useLoggly()
  /* --------------------------------------------- */
  const playerRef = useRef(null)
  const isTrailerRef = useRef(false)
  const detailsRef = useRef({})
  const sharePopupRef = useRef(null)
  const mediaPopupRef = useRef(null)
  /* --------------------------------------------- */
  const { addFavourites, deleteFavourites, isFavouritedItem } = useFavApi()
  const {
    userToken, isAuthenticated, isCastConnectedStatus,
    isMobileUser, isAutoplay: globalAutoplay, favouritesCallState,
    dispatch: globalDispatch, appLanguage, isThisCREATE, userInfo, guestLoginStatus
  } = useContext(GlobalContext)
  /* --------------------------------------------- */
  const playerFeature = useSelector(store => store.featuresReducers.playerFeature) || {}
  const { userManagementConfig = {} } = useSelector(store => store.userManagement)
  /* --------------------------------------------- */
  const userInfoRef = useRef(userInfo)
  /* --------------------------------------------- */
  const { sendAnalytics } = useAnalytics()
  /* --------------------------------------------- */
  const { showLoginPopup } = userManagementConfig
  /* --------------------------------------------- */
  /**
   * It: Converts duration format 1h 20min -> 01:20
   */
  const convertDuration = (e) => {
    let hourValue = "00"
    let minValue = "00"
    let array1 = []
    let array2 = []
    if (e) {
      e = e.toLowerCase()
      if (e.includes('h')) {
        array1 = e.split("h")
        hourValue = array1[0].trim()
      }
      if (e.includes('min')) {
        if (e.includes('h')) {
          array1 = e.split("h")
          array2 = array1[1].split("min")
          minValue = array2[0].trim()
        }
        else {
          array2 = e.split("min")
          minValue = array2[0].trim()
        }
      }
      if (hourValue.length < 2) hourValue = "0" + hourValue
      if (minValue.length < 2) minValue = "0" + minValue
      return hourValue + ":" + minValue + ":00"
    }
    return "00:00:00"
  }
  /* --------------------------------------------- */
  const getAppDetails = {
    title,
    currentPosterImage,
    releaseYear,
    parentalControl,
    isCcAvailable,
    isHdAvailable,
    type,
    duration
  }
  /* --------------------------------------------- */
  useEffect(() => {
    userInfoRef.current = userInfo
  }, [userInfo])
  /* --------------------------------------------- */
  useEffect(() => {
    detailsRef.current = { ...detailsSectionData, uid: movieSeriesId, episodeTitle }
  }, [detailsSectionData, movieSeriesId, episodeTitle])
  /* --------------------------------------------- */
  /**
   * It: Sets poster image for movies & previews.
   */
  useEffect(() => {
    if (dataLoading) return
    if (images.length && type !== 'series') setCurrentPosterImage(images)
  }, [images, type, dataLoading])
  /* --------------------------------------------- */
  /**
   * It: Sets poster image for series.
   */
  useEffect(() => {
    if (dataLoading) return
    if (type === 'series') {
      const imgs = (!activeSeason?.images || activeSeason?.images?.length === 0) ? images : activeSeason?.images
      setCurrentPosterImage(imgs)
    }
  }, [type, activeSeason, dataLoading, images])
  /* --------------------------------------------- */
  /**
   * It: Sets trailer url in a state.
   */
  useEffect(() => {
    if (type === 'preview') {
      updateCurrentTrailer(streams || '')
    } else if (type === 'series') {
      if (activeSeason?.trailers && activeSeason.trailers?.length > 0) {
        updateCurrentTrailer(activeSeason?.trailers[0]?.streams)
      } else updateCurrentTrailer(null)
    } else if (trailers && trailers.length > 0) {
      updateCurrentTrailer(trailers[0]?.streams)
    }
    else updateCurrentTrailer(null)
  }, [trailers, activeSeason, type, streams])
  /* --------------------------------------------- */
  /**
   * It: Sets active season in a state.
   */
  useEffect(() => {
    const queryStringObj = utils.parse(location.search) || {}
    let qSeasonNumber = Number(queryStringObj?.seasonNumber || -1)
    let selectedSeasonNumber = qSeasonNumber
    if (selectedSeasonNumber === -1) {
      const stateSeasonNumber = (location.state || {}).seasonNumber || -1
      selectedSeasonNumber = stateSeasonNumber
    }
    if (selectedSeasonNumber > -1 && seasonData.length) {
      seasonData.map(item => {
        if (item?.seasonNumber === selectedSeasonNumber) {
          updateActiveSeason(item || {})
        }
        return null
      })
    } else if (seasonNumber && seasonData?.length !== 0) {
      // Find season data that matches currently watching season's number 
      const season = seasonData.filter(season => seasonNumber === season?.seasonNumber)
      if (season?.length !== 0) {
        updateActiveSeason(season[0] || {})
      } else if (season?.length === 0) {
        // If not match found using currently watching season's number, select the next season as active season
        const active = seasonData.find(season => season?.seasonNumber > seasonNumber)
        updateActiveSeason(active || {})
      } else {
        // If no matches found, use first available season data
        updateActiveSeason(seasonData[0] || {})
      }
    } else if (seasonData && seasonData?.length !== 0) {
      updateActiveSeason(seasonData[0] || {})
    } else {
      updateActiveSeason({
        seasonNumber: seasonNumber
      })
    }
  }, [seasonData, seasonNumber, location.state, location.search])
  /* --------------------------------------------- */
  /**
   * It: Sets season description in a state.
   */
  useEffect(() => {
    activeSeason && updateDescriptionData(activeSeason.description)
  }, [activeSeason])
  /* --------------------------------------------- */
  /**
   * It: Toggles favourite icon.
   */
  useEffect(() => {
    if (favouritesCallState !== 'ENDED') return
    if (!catalogFeature.allowFavoriting) return
    if (baseUrl) {
      const isFavourited = isFavouritedItem(baseUrl, movieSeriesId)
      if (isFavourited) {
        setIsShowFavouriteIcon(true)
        updateIsFavourite(true)
      } else {
        setIsShowFavouriteIcon(true)
        updateIsFavourite(false)
      }
    }
  }, [baseUrl, movieSeriesId, isFavouritedItem, catalogFeature.allowFavoriting, favouritesCallState])
  /* --------------------------------------------- */
  /**
   * It: Formats duration.
   */
  useEffect(() => {
    if (displayDuration) {
      const duration = utils.millisToMinutesAndSeconds(displayDuration, {
        hr: appMessages.label_details_h,
        min: appMessages.label_details_min,
        sec: appMessages.label_details_sec
      })
      updateDuration(duration)
    }
  }, [
    displayDuration,
    appMessages.label_details_h,
    appMessages.label_details_min,
    appMessages.label_details_sec
  ])
  /* --------------------------------------------- */
  //----- Dealing with JSON-LD for SEO
  useEffect(() => {

    let movieDuration = convertDuration(duration)
    /* --------------------------------------------- */
    let selectedSubTitleTrack = getSelectedSubtitleTrack()
    if (!selectedSubTitleTrack) selectedSubTitleTrack = 'none'
    else selectedSubTitleTrack = selectedSubTitleTrack.language
    /* --------------------------------------------- */
    const ogTitle = `${(appMessages.share_title_prefix || '')}${(title || '')}${(appMessages.share_title_suffix || '')}`
    /* --------------------------------------------- */
    if (type === 'series') {
      let totalEpisodes = 0
      let seasonObject = seasonData.map(e => {
        const details = e.details || []
        const director = (details || []).filter((detail) => {
          detail = detail || {}
          return detail.key === 'director'
        }).map(({ value }) => value)[0] || []
        const actor = (details || []).filter((detail) => {
          detail = detail || {}
          return detail.key === 'cast'
        }).map(({ value }) => value)[0] || []
        const genre = (details || []).filter((detail) => {
          detail = detail || {}
          return detail.key === 'genre'
        }).map(({ value }) => value)[0] || []

        totalEpisodes += e?.numberOfEpisodes || 0

        const seasonLD = {
          "@type": "TVSeason",
          "datePublished": '',
          "name": utils.isNotNull(e, 'title') ? `${e.title}` : '',
          "seasonNumber": utils.isNotNull(e, 'seasonNumber') ? `${e.seasonNumber}` : '',
          "numberOfEpisodes": utils.isNotNull(e, 'numberOfEpisodes') ? `${e?.numberOfEpisodes}` : 0,
          "abstract": utils.isNotNull(e.description) ? `${e.description}` : '',
          "startDate": '',
          "genre": genre.map(e => {
            return e.title || ''
          }),
          "director": director.map(e => {
            return { "@type": "Person", "name": utils.isNotNull(e, 'title') && `${e.title}` }
          }),
          "actor": actor.map(e => {
            return { "@type": "Person", "name": utils.isNotNull(e, 'title') && `${e.title}` }
          }),
          "countryOfOrigin": utils.isNotNull(details, 0, 'value', 0, 'title') ? `${details[0].value[0].title || ''}` : ''
        }

        if (e.trailers) {
          seasonLD.trailer = {
            "@type": "VideoObject",
            "name": utils.isNotNull(appMessages, 'label_details_play_trailer') && `${appMessages.label_details_play_trailer}`,
            "uploadDate": '',
            "description": utils.isNotNull(e.description) ? `${e.description}` : '',
            "thumbnailUrl": (e.images || []).map(e => { return `${e.url}` })
          }
        }

        return seasonLD
      })

      const details = activeSeason.details || []
      // seasonObject.push({"key": "pair"})
      // here we need to add all the episode details for each season.
      const director = (details || []).filter((detail) => {
        detail = detail || {}
        return detail.key === 'director'
      }).map(({ value }) => value)[0] || []
      const actor = (details || []).filter((detail) => {
        detail = detail || {}
        return detail.key === 'cast'
      }).map(({ value }) => value)[0] || []
      const genre = (details || []).filter((detail) => {
        detail = detail || {}
        return detail.key === 'genre'
      }).map(({ value }) => value)[0] || []

      setJsonLD({
        "@context": "http://schema.org",
        "title": ogTitle,
        "name": title,
        "url": utils.isNotNull(shareUrl) && `${shareUrl}`,
        "countryOfOrigin": `${utils.isNotNull(details, 0, 'value', 0, 'title') ? details[0].value[0].title : ""}`,
        "subtitleLanguage": utils.isNotNull(selectedSubTitleTrack) && selectedSubTitleTrack,
        "@type": "TVSeries",
        "abstract": descriptionData || '',
        "description": descriptionData || '',
        "startDate": '',
        "genre": genre.map(e => {
          return e.title || ''
        }),
        "director": director.map(e => {
          return { "@type": "Person", "name": utils.isNotNull(e, 'title') && `${e.title}` }
        }),
        "actor": actor.map(e => {
          return { "@type": "Person", "name": utils.isNotNull(e, 'title') && `${e.title}` }
        }),
        "image": currentPosterImage.map(e => { return `${e.url}` }),
        "dateCreated": utils.isNotNull(releaseYear) ? `${releaseYear}` : '',
        "numberOfSeasons": utils.isNotNull(seasonData, 'length') && seasonData.length,
        "numberOfEpisodes": totalEpisodes,
        "containsSeason": utils.isNotNull(seasonObject) && seasonObject
      })
    }
    else if (type === 'movie') {
      const director = (details || []).filter((detail) => {
        detail = detail || {}
        return detail.key === 'director'
      }).map(({ value }) => value)[0] || []
      const actor = (details || []).filter((detail) => {
        detail = detail || {}
        return detail.key === 'cast'
      }).map(({ value }) => value)[0] || []
      const genre = (details || []).filter((detail) => {
        detail = detail || {}
        return detail.key === 'genre'
      }).map(({ value }) => value)[0] || []

      setJsonLD({
        "@context": "http://schema.org",
        "title": ogTitle,
        "name": ogTitle,
        "url": utils.isNotNull(shareUrl) && `${shareUrl}`,
        "countryOfOrigin": `${utils.isNotNull(details, 2, 'value', 0, 'title') ? details[2].value[0].title : ""}`,
        "subtitleLanguage": utils.isNotNull(selectedSubTitleTrack) && selectedSubTitleTrack,
        "@type": "Movie",
        "abstract": description || '',
        "description": description || '',
        "dateCreated": utils.isNotNull(releaseYear) ? `${releaseYear}` : '',
        "director": director.map(e => {
          return { "@type": "Person", "name": utils.isNotNull(e, 'title') ? `${e.title}` : '' }
        }),
        "actor": actor.map(e => {
          return { "@type": "Person", "name": utils.isNotNull(e, 'title') ? `${e.title}` : '' }
        }),
        "genre": genre.map(e => {
          return e.title || ''
        }),
        "image": currentPosterImage.map(e => { return `${e.url}` }),
        "duration": utils.isNotNull(movieDuration) ? `${movieDuration}` : '',
        "trailer": {
          "@type": "VideoObject",
          "name": utils.isNotNull(appMessages, 'label_details_play_trailer') && `${appMessages.label_details_play_trailer}`,
          "uploadDate": utils.isNotNull(releaseYear) ? `${releaseYear}` : '',
          "description": utils.isNotNull(description) ? `${description}` : '',
          "thumbnailUrl": currentPosterImage.map(e => { return `${e.url}` })
        }
      })
    }
  }, [details, title, url, releaseYear, appMessages, descriptionData, activeSeason, description,
    appMessages.label_details_play_trailer, currentPosterImage, type, activeSeason.numberOfEpisodes, seasonData, trailers, duration, appMessages.label_details_trailer, shareUrl])
  /*------------------------------------*/
  /**
   * It: Resets player state.
   */
  const resetPlayer = useCallback(() => {
    if (playerRef.current) {
      playerRef.current.setPlayerLoading(false)
      playerRef.current.setIsPlayerLoaded(false)
      playerRef.current.setPlayerError(false)
      playerRef.current.autoPlay(false)
    }
  }, [])
  /* --------------------------------------------- */
  /**
   * It: Toggles more info popup.
   */
  const moreInfoHandler = () => {
    if (isMediaDeatilsPopup) {
      utils.enableScroll(mediaPopupRef)
      globalDispatch({ 
        type: 'POPUP_DETAILS', 
        value: {
          inViewport: false,
          useMargin: utils.hasMargin()
        }
      })
      updateIsMediaDeatilsPopup(false)
    }
    else {
      utils.disableScroll(mediaPopupRef)
      globalDispatch({ 
        type: 'POPUP_DETAILS', 
        value: {
          inViewport: true,
          useMargin: utils.hasMargin()
        }
      })
      updateIsMediaDeatilsPopup(true)
    }
  }
  /* --------------------------------------------- */
  /**
   * It: Shows warning popup.
   */
  const WarningClickHandle = useCallback(() => {
    updateIsShowWaringPopup(false)
  }, [])
  /* --------------------------------------------- */
  /**
   * It: Toggles season selector popup.
   */
  const seasonChooserHandle = () => {
    if (isSeasonPopup) {
      updateIsSeasonPopup(false)
    } else updateIsSeasonPopup(true)
  }
  /* --------------------------------------------- */
  /**
   * It: Naviagtes to favourites route.
   */
  const goToFavourites = useCallback(() => {
    history.push(routeMap.favourites)
  }, [history])
  /* --------------------------------------------- */
  /**
   * It: Sends Add/remove favourite api call.
   * It: Dispalys toast.
   * It: Sends favourites analytics.
   * It: Toggles favourite icon.
   */
  const favOnClickHandler = useCallback(() => {
    let isMounted = true
    if (isFavourite) {
      updateIsFavourite(false)
      showError({ type: 'RemoveFavouriteSuccess', value: { onPrimaryBtnClick: goToFavourites } })
      isAuthenticated && deleteFavourites(baseUrl, movieSeriesId).then(() => {
        if (!isMounted) return
        sendAnalytics({
          type: '_content.favourite',
          action: 'remove',
          attr: {
            content_offer_id: contentOfferId,
            content_id: contentGuid,
            item_id: contentGuid,
            content_title: title,
            content_type: type,
            recommendation_id: mediaInfo.recommendation_id,
            asset_id: mediaInfo?.uid
          }
        })
      }).catch(() => {
        if (!isMounted) return
        updateIsFavourite(true)
        hideAllErrors({ type: 'RemoveFavouriteSuccess' })
        showError({ type: 'GenericErrorRemoveFavourite' })
      })
    } else {
      updateIsFavourite(true)
      showError({ type: 'AddFavouriteSuccess', value: { onPrimaryBtnClick: goToFavourites } })
      const params = {
        language: splitLanguage(appLanguage)
      }
      isAuthenticated && addFavourites(baseUrl, movieSeriesId, params, detailsRef.current).then(() => {
        if (!isMounted) return
        sendAnalytics({
          type: '_content.favourite',
          action: 'add',
          attr: {
            content_offer_id: contentOfferId,
            content_id: contentGuid,
            item_id: contentGuid,
            content_title: title,
            content_type: type,
            recommendation_id: mediaInfo.recommendation_id,
            asset_id: mediaInfo?.uid
          }
        })
      }).catch(() => {
        if (!isMounted) return
        updateIsFavourite(false)
        hideAllErrors({ type: 'AddFavouriteSuccess' })
        showError({ type: 'GenericAddFavourite' })
      })
    }
    /* --------------------------------------------- */
    return () => {
      isMounted = false
    }
  }, [
    showError, hideAllErrors, goToFavourites,
    addFavourites, deleteFavourites, appLanguage,
    baseUrl, isAuthenticated, isFavourite, title, type, contentGuid,
    movieSeriesId, sendAnalytics, contentOfferId,  mediaInfo.recommendation_id, mediaInfo.uid
  ])
  /* --------------------------------------------- */
  /**
   * It: Closes season selector popup.
   * It: Updates activeSeason state.
   * It: Updates season number in route state.
   */
  const seasonListHandler = (e, index) => {
    updateIsSeasonPopup(false)
    handleCurrentSeasonChange(seasonData?.[index]?.seasonUid, seasonData?.[index]?.numberOfEpisodes)
    updateActiveSeason(seasonData?.[index])
    const { seasonNumber } = seasonData[index] || {}
    if (seasonNumber) {
      history.replace(`${decodeURIComponent(location.pathname)}`, { seasonNumber })
    }
  }
  /* --------------------------------------------- */
  /**
   * It: Displays toast.
   * It: Copies text to memory.
   * It: Sends share analytics event.
   */
  const copyLinkHandle = () => {
    showError({ type: 'CopyToClipboardSuccess' })

    const parsedURL = utils.parseUrl(shareUrl) || {}
    const queryParams = utils.parse(parsedURL.search) || {}
    delete queryParams.ssr
    const queryString = utils.stringify(queryParams) || ''
    const str = decodeURIComponent(`${parsedURL.protocol}//${parsedURL.host}${parsedURL.pathname}?${queryString}`)

    const el = document.createElement('textarea') // Create a <textarea> element
    el.value = str // Set its value to the string that you want copied
    el.setAttribute('readonly', '') // Make it readonly to be tamper-proof
    el.style.position = 'absolute'
    el.style.left = '-9999px' // Move outside the screen to make it invisible
    document.body.appendChild(el) // Append the <textarea> element to the HTML document
    const selected =
      document.getSelection().rangeCount > 0 // Check if there is any content selected previously
        ? document.getSelection().getRangeAt(0) // Store selection if found
        : false // Mark as false to know no selection existed before
    el.select() // Select the <textarea> content
    document.execCommand('copy') // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el) // Remove the <textarea> element
    if (selected) { // If a selection existed before copying
      document.getSelection().removeAllRanges() // Unselect everything on the HTML document
      document.getSelection().addRange(selected) // Restore the original selection
    }

    sendAnalytics({
      type: '_content.share',
      attr: {
        content_offer_id: contentOfferId,
        content_id: contentGuid,
        item_id: contentGuid,
        content_title: title,
        content_type: type,
        share_target: 'copy url',
        share_link: str
      }
    })
  }
  /* --------------------------------------------- */
  /**
   * It: Toggles share popup.
   */
  const shareOnclickHandle = () => {
    if (sharePopUp) {
      utils.enableScroll(sharePopupRef)
      globalDispatch({ 
        type: 'POPUP_DETAILS', 
        value: {
          inViewport: false,
          useMargin: utils.hasMargin()
        }
      })
      UpdateSharePopUp(false)
    }
    else {
      utils.disableScroll(sharePopupRef)
      globalDispatch({ 
        type: 'POPUP_DETAILS', 
        value: {
          inViewport: true,
          useMargin: utils.hasMargin()
        }
      })
      UpdateSharePopUp(true)
    }
  }
  /* --------------------------------------------- */
  /**
   * It: Show/Hide login popup based on contentful config & authentication state.
   */
  const authenticate = useCallback((callback = null, config = {}) => {
    const {guestPermitted} = config
  if (guestPermitted && guestLoginStatus === 'SUCCESS') {
    if (callback) callback()
      return
  }
    if (!isAuthenticated && (showLoginPopup === 'OnPlayback' || showLoginPopup === 'OnSplash')) {
      globalDispatch({ type: 'SHOW_LOGIN_POPUP' })
      if (identityProvider === "mpx") {
        globalDispatch({
          type: 'LOGIN_POPUP_DETAILS',
          value: {
            isShowCloseIcon: true,
            onSignupClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
              history.push(routeMap.signup)
            },
            onLoginClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
              history.push(routeMap.login)
            },
            onCloseClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
            }
          }
        })
      } else {
        globalDispatch({
          type: 'LOGIN_POPUP_DETAILS',
          value: {
            isShowCloseIcon: true,
            onCloseClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
            }
          }
        })
      }

    } else {
      globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
      globalDispatch({
        type: 'LOGIN_POPUP_DETAILS', value: {}
      })
      if (callback) callback()
    }
  }, [globalDispatch, isAuthenticated, showLoginPopup, history, identityProvider, guestLoginStatus])
  /* --------------------------------------------- */
  /**
   * It: Dispatches cast data.
   */
  const castHandlePlayClick = useCallback((e, trailer) => {
    if (!isCastConnectedStatus || !isAuthenticated) return
    let isTrailer = false
    let playbackFormat = castConfigPlaybackFormat
    if (trailer) {
      isTrailer = true
      playbackFormat = previewAssetFormat
    }

    /* --------------------------------------------- */
    authenticate(() => {
      if (isMobileUser) {
        globalDispatch({
          type: 'GETAPP_POPUP_DETAILS',
          value: {
            isShowPopup: true,
            details: getAppDetails
          }
        })
      } else {
        const lang = getAppLanguageWithoutRegion()
        const userInfo = userInfoRef.current
        const userId = userInfo.userId
        globalDispatch({
          type: 'CAST_DATA',
          data: {
            baseUrl,
            userId,
            userType: userInfo.customerType || '',
            userEmailHash: userInfo.emailHash,
            mediaId: isTrailer ? movieSeriesId : mediaId,
            isTrailer,
            seasonTrailerUrl: currentTrailer,
            seasonNumber: activeSeason.seasonNumber,
            autoplay: globalAutoplay,
            token: userToken || '',
            lang,
            isLinear: isLivePlayer || type === 'live',
            castConfigPlaybackFormat: playbackFormat,
            progress: progress / 1000,
            userSource: userInfo.source
          }
        })
        /* --------------------------------------------- */
        log({
          type: 'Info', attr: {
            module: 'Cast',
            cast_info: {
              playback_action: 'cast_initiated',
              isTrailer,
              autoplay: globalAutoplay,
              lang,
              content_title: title,
              castConfigPlaybackFormat: playbackFormat,
              content_id: mediaId,
            }
          }
        })
      }
    }, { guestPermitted: detailsSectionData.purchaseMode === 'free' })
  }, [
    type, 
    isLivePlayer,
    baseUrl,
    mediaId,
    authenticate,
    previewAssetFormat,
    globalDispatch,
    userToken,
    getAppDetails,
    log,
    title,
    movieSeriesId,
    currentTrailer,
    isMobileUser,
    globalAutoplay,
    isCastConnectedStatus,
    activeSeason.seasonNumber,
    castConfigPlaybackFormat,
    progress,
    detailsSectionData.purchaseMode,
    isAuthenticated
  ])
  /* --------------------------------------------- */
  /**
   * It: Sets playback url in a state.
   * It: Displays GetAppPopup when not authenticated.
   */
  const handlePlayClick = useCallback(() => {
    if (!url || !playerRef.current.play) return
    authenticate(() => {
      if (isMobileUser) {
        globalDispatch({
          type: 'GETAPP_POPUP_DETAILS',
          value: {
            isShowPopup: true,
            details: getAppDetails
          }
        })
      } else {
        isTrailerRef.current = false
        setPlayerUrl(url)
        globalDispatch({
          type: 'GETAPP_POPUP_DETAILS',
          value: {
            isShowPopup: false,
            details: null
          }
        })
        playerRef.current.play(isTrailerRef.current, {
          progress,
          duration: displayDuration
        }, { ...detailsRef.current, streams: url, assetDetailsForRelatedRailInPlayer: {
          movieSeriesId, detailsSectionData, dataLoading, identityProvider, pageName
        } })
      }
    }, { guestPermitted: detailsSectionData.purchaseMode === 'free' })
  }, [url, authenticate, detailsSectionData, isMobileUser, globalDispatch, getAppDetails, progress, displayDuration, movieSeriesId, dataLoading, identityProvider, pageName])
  /* --------------------------------------------- */
  /**
   * It: Sets trailer playback url in a state.
   * It: Displays GetAppPopup when not authenticated.
   */
  const handleTrailerPlayClick = useCallback(() => {
    authenticate(() => {
      if (isMobileUser) {
        globalDispatch({
          type: 'GETAPP_POPUP_DETAILS',
          value: {
            isShowPopup: true,
            details: getAppDetails
          }
        })
      } else {
        isTrailerRef.current = true
        setPlayerUrl(currentTrailer)
        globalDispatch({
          type: 'TRAILER_DETAILS',
          value: {
            isTrailer: true,
            trailerUrl: currentTrailer
          }
        })
        playerRef.current.play(isTrailerRef.current, {
          progress: 0,
          duration: displayDuration
        }, { ...detailsRef.current, streams: currentTrailer })
      }
    }, { guestPermitted: true })
  }, [getAppDetails, globalDispatch, currentTrailer, isMobileUser, authenticate, displayDuration])
  /* --------------------------------------------- */
  /**
   * It: Sets playback url in a state.
   */
  useEffect(() => {
    if (!url && (!playerRef.current || !playerRef.current.play)) return
    setPlayerUrl(url)
  }, [url])
  /* --------------------------------------------- */
  /**
   * It: Sets share url in a state.
   */
  useEffect(() => {
    const queryStringObj = utils.parse(location.search) || {}
    let qSeasonNumber = Number(queryStringObj.seasonNumber || -1)
    let selectedSeasonNumber = qSeasonNumber
    if (selectedSeasonNumber === -1) {
      const stateSeasonNumber = (location.state || {}).seasonNumber || -1
      if (stateSeasonNumber === -1 && seasonNumber) {
        selectedSeasonNumber = seasonNumber
      } else {
        selectedSeasonNumber = stateSeasonNumber
      }
    }

    if (!catalogFeature.shareUrl) return

    const noWhiteSpaceTitle = (title || '').replace(/[\s||.$]/g, '-').replace(/[$&+,/:;=?@"<>'#%{}|\\^~[\]]/g, '')
    let shareUrl = catalogFeature.shareUrl
      .replace(/{media_type}/g, pageName)
      .replace(/{media_type_id}/g, params.type)
      .replace(/{media_id}/g, movieSeriesId)
      .replace(/{media_title}/g, noWhiteSpaceTitle)
      .replace(/{season_no}/g, selectedSeasonNumber)

    const parsedURL = utils.parseUrl(shareUrl)
    const queryParams = utils.parse(parsedURL.search) || {}

    if (type !== 'series') delete queryParams.seasonNumber

    const queryString = `${utils.stringify(queryParams)}`
    shareUrl = decodeURIComponent(`${parsedURL.protocol}//${parsedURL.host}${parsedURL.pathname}?${queryString}`)
    setShareUrl(shareUrl)
  }, [type, catalogFeature.shareUrl, movieSeriesId, seasonNumber, location.state, location.search, params.type, title, pageName])
  /* --------------------------------------------- */
  /**
   * It: Show/Hide login popup based on contentful config & authentication state.
   * It: Casts data.
   * It: Logs cast event.
   */
  const onPlayClick = () => {
    if (isProductLoading) return
    const authenticate = (callback = null, config = {}) => {
      const {guestPermitted} = config
      if (guestPermitted && guestLoginStatus === 'SUCCESS') {
        if (callback) callback()
          return
      }
      if (!isAuthenticated &&
        (showLoginPopup === 'OnPlayback' || showLoginPopup === 'OnSplash')) {
        globalDispatch({ type: 'SHOW_LOGIN_POPUP' })
        globalDispatch({
          type: 'LOGIN_POPUP_DETAILS',
          value: {
            isShowCloseIcon: true,
            onSignupClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
              history.push(routeMap.signup)
            },
            onLoginClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
              history.push(routeMap.login)
            },
            onCloseClick: () => {
              globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
            }
          }
        })
      } else {
        if (isPurchasedProduct === 0) {
          updateIsShowWaringPopup(true)
          log({
            type: 'Error',
            module: 'Authentication',
            attr: {
              event: 'SubscriptionRequired',
              error_shown: true, 
              pageUrl:window.location.href
            }
          })
        } else {
          globalDispatch({ type: 'HIDE_LOGIN_POPUP' })
          globalDispatch({
            type: 'LOGIN_POPUP_DETAILS', value: {}
          })
          if (callback) callback()
        }
      }
    }
    authenticate(() => {
      if (isCastConnectedStatus && isAuthenticated) {
        const lang = getAppLanguageWithoutRegion()
        const userInfo = userInfoRef.current
        const userId = userInfo.userId
        globalDispatch({
          type: 'CAST_DATA',
          data: {
            baseUrl,
            mediaId,
            userId,
            userType: userInfo.customerType || '',
            userEmailHash: userInfo.emailHash,
            userSource: userInfo.source,
            autoplay: globalAutoplay,
            token: userToken || '',
            lang,
            isLinear: isLivePlayer,
            castConfigPlaybackFormat,
            progress: progress / 1000
          }
        })
        /* --------------------------------------------- */
        log({
          type: 'Info', attr: {
            module: 'Cast',
            cast_info: {
              playback_action: 'cast_initiated',
              isTrailer: false,
              autoplay: globalAutoplay,
              lang,
              content_title: title,
              castConfigPlaybackFormat,
              content_id: mediaId,
            }
          }
        })

      } else {
        if (!url || !playerRef.current.play) return
        playerRef.current.play(true, {}, detailsRef.current)
      }
    }, { guestPermitted:  detailsSectionData.purchaseMode === 'free'  })
  }
  /* --------------------------------------------- */
  /**
   * It: Plays live channel.
   */
  const playLiveChannelInPlayer = () => {
    const state = {
      "details": {
        "url": "https://link.theplatform.com/s/tzTJhC/media/ad_yEfI0NVSl",
        "title": `${title ? title : 'Relativity'}`,
        "subTitle": null,
        "details": [
          {
            "key": "date"
          },
          {
            "key": "association"
          },
          {
            "key": "countries",
            "label": "Country",
            "value": null
          },
          {
            "key": "availableTill",
            "label": "Available For",
            "value": null
          },
          {
            "key": "genre",
            "label": "Genre",
            "value": [
              {
                "title": "History"
              },
              {
                "title": "Documentary"
              }
            ]
          },
          {
            "key": "cast",
            "label": "Cast",
            "value": null
          },
          {
            "key": "director",
            "label": "Director",
            "value": null
          }
        ],
        "description": "Example content containing multi-language captions and audio.",
        "timeLeft": 0,
        "mediaId": "277046310581",
        "seriesId": "",
        "seasonId": null,
        "trailers": [],
        "movieSeriesId": "277046310581",
        "castConfigPlaybackFormat": "MPEG-DASH+widevine",
        "isLivePlayer": false,
        "isShowFavourites": false,
        "isSportingEvent": false,
        "seasonData": null,
        "curentSeason": null,
        "type": "movie",
        "appMessages": {
          "error_ext": "Exit",
          "error_media_access_fail": "Failed to access media.\n",
          "error_no_content": "No matching items found",
          "error_no_internet": "Unable to stream. Please check your internet connection.",
          "error_no_network_desc": "Unable to connect to the server. Please check your network",
          "error_retry": "Retry",
          "error_something_wrong": "Something went wrong.\n",
          "error_stream_fetch": "There was an error fetching the stream information.",
          "error_video_unsupported": "Video format unsupported",
          "app_popup_stream_not_found": "The requested stream is not found",
          "error_media_content_unavailable_in_your_country": "This content is not available in your country",
          "error_media_access_denied": "You don't have access to play this content",
          "error_media_concurrency_limit_violation_auth": "Concurrency error occurred",
          "label_error_still_not_working": "Still not working?",
          "label_error_view_faq": "View FAQ",
          "label_error_removed_from_favourites": "Removed from favourites",
          "label_error_failed_remove_favourites": "Failed to removed from favourites",
          "label_error_failed_add_favourites": "Failed to Add in favourites",
          "error_media_concurrency_limit_violation_auth_desc": "This media is already being played somewhere using your credential",
          "error_media_content_unavailable_in_your_country_desc": "This content is not available for your current geo location",
          "error_media_access_denied_desc": "You are not authenticated to view this content",
          "error_something_wrong_desc": "Sorry, unknown error occured",
          "error_no_network": "No Network",
          "error_no_license_granted": "Valid entitlement license not granted",
          "error_no_license_granted_desc": "Valid entitlement license not granted for the user",
          "error_code": "ERROR CODE",
          "account_other_settings_language": "Language",
          "customer_care_contact_us_title": "Contact Us",
          "customer_care_faq_title": "FAQ",
          "customer_care_privacy_title": "Privacy Policy",
          "customer_care_terms_contact_us": "Contact Us",
          "customer_care_terms_term_of_use": "Term of Use",
          "customer_care_terms_title": "Terms of Use",
          "media_label_on_now": "On Now",
          "player_quality_selector": "Playback Quality",
          "search": "Search shows & movies",
          "search_form_default": "Search",
          "search_no_results": "No results found",
          "search_result_title": "Search Results",
          "search_suggestion": "Suggestions",
          "settings_app_language": "App language",
          "details_related": "Related",
          "listing_empty_page": "No content to list",
          "catalog_related_movie": "Related",
          "catalog_related_series": "Related",
          "catalog_label_on_now": "On Now",
          "label_empty_page": "No items found",
          "label_catalog_time_left_label_suffix": "min left",
          "label_catalog_unit_hour": "h",
          "label_catalog_unit_minute": "min",
          "label_catalog_appletv_version": "VERSION",
          "label_catalog_share_title": "Choose One ",
          "details_days": "Days",
          "details_day": "Day",
          "details_hours": "Hours",
          "details_hour": "Hour",
          "details_minutes": "Minutes",
          "details_minute": "Minute",
          "details_seconds": "Seconds",
          "details_second": "Second",
          "details_date": "Date",
          "details_date_st": "st",
          "details_date_nd": "nd",
          "details_date_rd": "rd",
          "details_date_th": "th",
          "details_api_date_format": "yyyy-MM-dd",
          "button_close": "Close",
          "button_ok": "OK",
          "button_update": "Update",
          "button_retry": "Retry",
          "login_register": "REGISTER NOW",
          "login_login": "SIGN IN",
          "button_intro_get_started": "GET STARTED",
          "button_intro_next": "NEXT",
          "button_mobile_web_primary": "Get the App",
          "button_mobile_web_secondary": "Browse",
          "button_web_app_download_banner": "Download",
          "button_cancel": "Cancel",
          "button_web_app_dismiss": "Dismiss",
          "footer_copyright": "Diagnal © 2020",
          "en": "English",
          "fr": "French",
          "label_details_subtitle_prefix": "V.O.:",
          "label_details_episode": "Episode",
          "label_details_country": "Country",
          "label_details_available_for": "Available For",
          "label_details_genre": "Genre",
          "label_details_cast": "Cast",
          "label_details_director": "Director",
          "label_details_show_less": "SHOW LESS",
          "label_details_show_more": "SHOW MORE",
          "label_details_season": "Season ",
          "label_details_trailer": "Trailer",
          "label_details_episode_prefix": "Ep",
          "label_details_season_prefix": "S",
          "label_details_seasons": "Seasons",
          "label_details_h": "h",
          "label_details_min": "min",
          "label_details_sec": "sec",
          "label_details_add_favourite": "Added to favourite",
          "label_details_go": "Go",
          "label_details_play": "PLAY",
          "label_details_cc": "CC",
          "label_details_hd": "HD",
          "label_details_more_info": "MORE INFO",
          "label_details_episodes": "Episodes",
          "label_details_related": "Related",
          "label_details_add_downloads": "Added to downloads",
          "label_details_play_trailer": "PLAY TRAILER",
          "label_details_use_mobile_data": "Use mobile data?",
          "label_details_mobile_data_description": "You’re about to stream the video on your mobile data. Are you sure?",
          "details_play": "Play",
          "details_cancel": "Cancel",
          "label_details_copy_link": "COPY LINK",
          "label_details_share": "Share",
          "label_details_resume": "Resume",
          "label_details_favourite": "FAVOURITE",
          "label_details_unfavourite": "UNFAVOURITE",
          "label_details_url_copied": "URL copied to clipboard",
          "label_player_subtitles": "Subtitles",
          "label_player_language_options": "Language Options",
          "label_player_subtitle": "Subtitles",
          "label_player_auto": "Auto",
          "label_player_off": "off",
          "label_player_season_no": "Season #",
          "label_player_episode_no": "Episode",
          "label_player_next": "Next",
          "label_player_quality_selector": "Playback Quality",
          "subtitle_none": "Off",
          "subtitle_en": "English",
          "subtitle_fr": "French",
          "quality_auto": "Auto",
          "label_playing_on_tv_screen": "Now playing on your TV screen",
          "player_control_next": "Next",
          "subtitle_un": "",
          "player_label_mute": "Mute",
          "player_label_unmute": "Unmute",
          "label_binge_up_next": "UP NEXT",
          "label_binge_episode": "Episode",
          "label_binge_starting_in": "Starting in",
          "label_binge_seconds": "seconds",
          "binge_starting_now": "Starting now",
          "label_binge_up_next_on": "Up Next On",
          "label_binge_now_playing": "Now playing",
          "label_favourites_remove": "Remove",
          "label_favourites_edit": "Edit",
          "label_favourites_edit_favourites": "Edit Favourites",
          "label_favourites_done": "Done",
          "label_favourites": "Favourites",
          "label_settings_stream_mobile_data": "Stream on Mobile Data",
          "label_settings_stream_quality": "Stream Quality",
          "label_settings_autoplay_next_episode": "Autoplay Next Episode",
          "label_settings_download_mobile_data": "Download on Mobile Data",
          "label_settings_download_quality": "Download quality",
          "label_settings_download_storage": "Download Storage",
          "label_settings_internal": "Internal",
          "label_settings_sd_card": "SD Card",
          "label_settings_sd": "SD",
          "label_settings_hd": "HD",
          "label_settings_auto_play_on": "ON",
          "label_settings_auto_play_off": "OFF",
          "label_settings_version": "VERSION",
          "label_download_downloading": "DOWNLOADING",
          "label_download_mb": "MB",
          "label_download_sd_card": "SD Card",
          "label_download_available_for": "AVAILABLE FOR",
          "label_download_days": "DAYS",
          "label_download_expired": "EXPIRED",
          "label_download_total_storage_used": "Total Storage Used: ",
          "label_download_gb": "GB",
          "label_download_internal": "Internal",
          "label_download_edit_download": "Edit Downloads",
          "label_download_downloads": "Downloads",
          "label_download_day": "DAY",
          "label_download_paused": "PAUSED",
          "label_download_queued": "QUEUED",
          "label_download_preparing": "Preparing for download...",
          "label_download_kb": "KB",
          "label_web_app_download_banner_title": "",
          "label_web_app_download_banner_description": "Download the free app from the App Store or Google Play to watch Club illico on your mobile devices.",
          "label_download_season": "S",
          "label_download_episode": "E",
          "label_download_failed": "Failed",
          "label_download_no_play_sd_card": "No media to play in SD Card",
          "label_downloade_low_space_description": "You can free up space on this device by managing your storage in settings",
          "label_download_low_space_title": "Low space warning",
          "error_download_list_pause_data_restriction": "Paused on mobile data",
          "error_download_list_fetch": "Media Fetch Error",
          "error_download_list_parse": "Media Parse Error",
          "error_download_list_format": "Media Format Error",
          "error_download_list_drm": "DRM Error",
          "error_download_list_concurrency": "Concurrency Error",
          "error_download_list_geo_blocked": "Geo-blocked Error",
          "error_download_list_entitlement": "Entitlement Error",
          "error_download_list_preparing": "Preparing failed",
          "error_download_list_low_space": "Low space Error",
          "error_download_list_storage": "Storage Error",
          "error_download_list_network": "Network Error",
          "error_download_list_missing_files": "Missing Files",
          "label_download_low_space_description": "You can free up space on this device by managing your storage in settings",
          "error_download_list_generic": "Unknown error",
          "error_download_list_db_error": "Failed to insert data",
          "label_download_manager": "Download Manager",
          "label_recently_watched_continue_watching": "Continue Watching",
          "label_recently_watched_min": "min",
          "label_recently_watched_hr": "hr",
          "label_recently_watched_sec": "sec",
          "label_recently_watched_left": "left",
          "label_recently_watched_s": "S",
          "label_recently_watched_e": "E",
          "logout_popup_title": "Are you sure?",
          "logout_popup_description": "You will lose access to your shows and movies until you login again",
          "label_logout_cancel": "Cancel",
          "logout_popup_ok": "SIGN OUT",
          "label_component_view_all": "View All",
          "search_more_results": "More Results",
          "search_recent_search": "RECENT SEARCHES",
          "search_no_recent_search": "No Recent Search",
          "search_clear_all": "CLEAR ALL",
          "label_search_hint": "Search",
          "label_search_text": "Search Movies and Series",
          "label_search_result": "Results",
          "label_search_clear_search": "Clear Recent Searches",
          "label_search_suggestion": "Suggestions",
          "login_poup_title": "You are one step away!",
          "login_poup_yes": "YES",
          "registration_poup_title": "Already got an account?",
          "label_popup_download_limit": "Maximum downloads exceeded",
          "label_goto_downloads": "Do you want to go to download page?",
          "login_popup_yes": "YES",
          "login_popup_no": "NO",
          "label_login_progress_description": "Waiting for sign-in to complete",
          "label_mobile_web_primary_text": "Watch Club Illico on your phone or tablet",
          "label_mobile_web_secondary_text": "Download the free app from the App Store or Google Play to watch Club illico on your mobile devices.",
          "label_mobile_web_confirm_text": "Or continue browsing here",
          "label_popup_change_settings_mobile_data": "Change in Settings to Download on Mobile Data",
          "label_chromecast_cast_to": "Cast to",
          "label_chromecast_casting_to": "Casting to",
          "label_chromecast_start_cast": "Starting Cast to",
          "label_chromcast_up_next_on": "Up Next on",
          "label_chromecast_cast": "Casting",
          "label_intro_skip": "Skip",
          "label_intro_next": "NEXT",
          "label_intro_get_started": "GET STARTED",
          "label_login_banner_title": "Connect to your Account",
          "label_login_description": "Enter the code above to sign-in on Club Illico’s website at",
          "label_login_or_description": "or scan the QR code below with your mobile phone or tablet to access the website",
          "label_login_send_code": "SEND CODE AGAIN",
          "contact_us_subtitle": "",
          "contact_us_link_description": "",
          "contact_us_phone_description": "",
          "contact_us_email_description": "",
          "contact_us_phone_no": "",
          "contact_us_link": "",
          "contact_us_link_label": "",
          "label_log_in_account": "Don't have an account?",
          "label_log_in_sign_up": "SIGN UP",
          "label_sign_up_or": "or",
          "label_forgot_password_log_in": "LOG IN",
          "label_log_in_forgot_password": "Forgot Password?",
          "label_sign_up_please_enter_password": "Please enter password",
          "label_sign_up_please_enter_email": "Please enter email",
          "label_account_recovery_change_password": "CHANGE PASSWORD",
          "label_account_recovery_new_password": "Create a new password below and you're good to go",
          "label_account_recovery_reset_password": "Reset Password",
          "label_sign_up_error_password_missmatch_confirm_password": "Password mismatch in confirm password",
          "label_sign_up_confirm_password": "Confirm Password",
          "label_sign_up_password": "Password",
          "label_sign_up_already_account": "Already got an account?",
          "label_sign_up_agree_terms_of_use_and_privacy_policy": "I have read and agree to the ",
          "label_sign_up_create_account": "Create your account",
          "label_sign_up_unlock_exclusive_match_and_live_content": "Unlock exclusive matches and live content",
          "label_sign_up_receive_promotional_messages": "I would like to receive promotional messages",
          "label_forgot_password_send_email": "SEND EMAIL",
          "label_forgot_password_it_is_alright": "It's alright",
          "label_forgot_password_email": "Enter your email below and we'll get it sorted",
          "label_account_info_your_profile": "Your Profile",
          "label_account_info_about_yourself": "Tell us a bit about yourself",
          "label_account_info_first_name_invalid": "Invalid first name ",
          "label_account_info_last_name_invalid": "Invalid last name",
          "label_sign_up_please_enter_date_of_birth": "Please enter Date of Birth",
          "label_sign_up_please_enter_gender": "Please enter gender",
          "label_account_info_start_watching": "START WATCHING",
          "label_account_info_skip_for_now": "Skip for now",
          "label_account_info_first_name": "First Name",
          "label_account_info_last_name": "Last Name",
          "label_account_info_date_of_birth": "Date of Birth",
          "label_account_info_gender": "Gender",
          "label_sign_up_email": "Email",
          "label_sign_up_error_enter_valid_email": "Enter a valid email ",
          "label_sign_up_error_minimum_password_character": "Minimum number of characters is ",
          "label_account_edit_profile": "Edit Profile",
          "label_account_password": "Password",
          "label_change_password_text": "Change your password regularly",
          "label_account_change": "Change",
          "label_account_purchase_history": "Purchase History",
          "label_purchase_history_text": "See all the passes you've purchased",
          "label_account_view": "View",
          "label_account_current_password": "Current Password",
          "label_sign_up_error_minimum_first_name_character": "Minimum characters for first name is ",
          "label_sign_up_error_maximum_last_name_character": "Maximum characters for last name is ",
          "label_profile_new_profile": "CREATE A NEW PROFILE",
          "label_profile_update_pin": "UPDATE KIDS PIN",
          "label_profile_popup_title": "Profiles",
          "label_profile_kids_avatar_label": "Kids",
          "label_profile_popup_title_edit_profile": "Edit Profiles",
          "label_profile_edit_profile_name": "Profile name",
          "label_profile_edit_profile_edit_profile": "Edit Profile",
          "label_profile_edit_profile_kids_profile": "Kids Profile",
          "label_profile_edit_profile_kids_profile_description": "Enable Kid's only experience with titles suitable for Kids  ",
          "label_profile_edit_profile_push_notification": "Push notifications",
          "label_profile_edit_profile_push_notification_description": "Enable to receive relevant push notifications for this profile",
          "label_profile_edit_profile_button_save_changes": "SAVE CHANGES",
          "label_profile_edit_profile_button_cancel": "CANCEL",
          "label_profile_edit_profile_delete_popup_title": "Are you sure?",
          "label_profile_edit_profile_delete_popup_description": "All of the data associated with this profile will also be deleted. This cannot be undone.",
          "label_profile_edit_profile_delete_popup_button_confirm": "CONFIRM",
          "label_profile_edit_profile_delete_popup_button_cancel": "CANCEL",
          "label_profile_edit_profile_require_pin_profile_exit_description": "Enable to make Kid's pin mandatory for switching out from this profile. ",
          "label_profile_edit_profile_require_pin_profile_exit": "Require Kids PIN on profile exit",
          "label_profile_edit_profile_avatar_kids": "Kids",
          "label_profile_create_profile_create_profile": "Create Profile",
          "label_profile_create_profile_profile_name": "Profile name",
          "label_profile_create_profile_kids_profile": "Kids Profile",
          "label_profile_create_profile_kids_profile_description": "Enable Kid's only experience with titles suitable for Kids ",
          "label_profile_create_profile_push_notification": "Push notifications",
          "label_profile_create_profile_push_notification_description": "Enable to receive relevant push notifications for this profile",
          "label_profile_create_profile_button_create_profile": "CREATE PROFILE",
          "label_profile_create_profile_button_cancel": "CANCEL",
          "label_profile_create_profile_avatar_kids": "Kids",
          "label_profile_create_profile_require_pin_profile_exit_description": "Enable to make Kid's pin mandatory for switching out from this profile. ",
          "label_profile_create_profile_require_pin_profile_exit": "Require Kids PIN on profile exit",
          "label_profile_create_profile_profile_created_toast": "has been created",
          "label_profile_popup_create_kids_pin_popup_title": "Create Kids PIN",
          "label_profile_popup_create_kids_pin_popup_description": "Kids PIN is required to change a kids profile to full access and can also be used to control exit from a kids profile.",
          "label_profile_popup_create_kids_pin_popup_button_next": "NEXT",
          "label_profile_popup_create_kids_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_create_kids_pin_popup_only_number_warning": "Please only use numbers for your PIN.",
          "label_profile_popup_new_kids_pin_confirm_popup_title": "Confirm Kids PIN",
          "label_profile_popup_new_kids_pin_confirm_popup_description": "Enter the same digits you’ve entered earlier to confirm.",
          "label_profile_popup_new_kids_pin_confirm_popup_button_done": "DONE",
          "label_profile_popup_new_kids_pin_confirm_popup_button_cancel": "CANCEL",
          "label_profile_popup_new_pin_created_popup_title": "Kids PIN created",
          "label_profile_popup_new_pin_created_popup_description": "To change the Kids PIN, switch to any profile with full access.",
          "label_profile_popup_new_pin_created_popup_button_ok": "OK",
          "label_profile_popup_verify_pin_popup_title": "Enter Kids PIN",
          "label_profile_popup_verify_pin_popup_description": "Before you can change the kids PIN, please enter the existing PIN.",
          "label_profile_popup_verify_pin_popup_forgot_pin": "Forgot PIN",
          "label_profile_popup_verify_pin_popup_button_next": "NEXT",
          "label_profile_popup_verify_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_verify_pin_popup_wrong_pin_toast": "The PIN you’ve entered is incorrect",
          "label_profile_popup_wrong_pin_popup_title": "Reset Kids PIN?",
          "label_profile_popup_wrong_pin_popup_description": "You’ve entered an incorrect PIN five times already. Would you like to reset your Kids PIN? This requires you to login again before setting a new PIN.",
          "label_profile_popup_wrong_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_wrong_pin_popup_button_confirm": "CONFIRM",
          "label_profile_popup_forgot_pin_popup_title": "Forgot Kids PIN?",
          "label_profile_popup_forgot_pin_popup_description": "Would you like to reset your Kids PIN? This requires you to login again before setting a new PIN.",
          "label_profile_popup_forgot_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_forgot_pin_popup_button_reset": "RESET",
          "label_profile_popup_change_pin_popup_title": "Change Kids PIN",
          "label_profile_popup_change_pin_popup_description": "Kids PIN is required to change a kids profile to full access and can also be used to control exit from a kids profile.",
          "label_profile_popup_change_pin_popup_button_done": "DONE",
          "label_profile_popup_change_pin_popup_button_cancel": "CANCEL",
          "label_profile_popup_change_pin_confirmation_popup_title": "Kids PIN changed",
          "label_profile_popup_change_pin_confirmation_popup_description": "The new kids PIN can now be used to control exit from a kids profile",
          "label_profile_popup_change_pin_confirmation_popup_button_ok": "OK",
          "label_profile_popup_exit_kids_popup_title": "Enter Kids PIN",
          "label_profile_popup_exit_kids_popup_description": "Please enter your Kids PIN to switch out of this profile.",
          "label_profile_popup_exit_kids_popup_button_done": "DONE",
          "label_profile_popup_exit_kids_popup_button_cancel": "CANCEL",
          "label_profile_popup_exit_kids_popup_forgot_pin": "FORGOT PIN",
          "label_profile_popup_max_profiles_popup_title": "Maximum profiles reached",
          "label_profile_popup_max_profiles_popup_description": "You can only create five profiles. Please remove an existing profile before creating a new one.",
          "label_profile_popup_max_profiles_popup_button_ok": "OK"
        },
        "detailsType": "movie",
        "previewAssetFormat": "MPEG4,MPEG-DASH+widevine,MPEG-DASH+none",
        "theme": {
          "header": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(0, 0, 0, 1)",
              "secondary": "rgba(0, 0, 0, 1)",
              "tertiary": "rgba(0, 0, 0, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "curvedEdges": true
          },
          "body": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(43, 43, 43, 1)",
              "secondary": "rgba(0, 0, 0, 1)",
              "tertiary": "rgba(146, 146, 146, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(222, 222, 222, 1)",
              "error": null
            }
          },
          "footer": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 255, 255, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(0, 0, 0, 1)",
              "secondary": "rgba(115, 115, 115, 1)",
              "tertiary": "rgba(43, 43, 43, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(255, 255, 255, 1)",
              "tertiary": "rgba(222, 222, 222, 1)",
              "error": null
            }
          },
          "compositeStyle": {
            "calendarStyle": {
              "body": {
                "accent": {
                  "primary": "#f7f72a",
                  "secondary": "#FFF",
                  "tertiary": "#4d4d4d"
                },
                "background": {
                  "primary": "#f7f72a",
                  "secondary": "#333333",
                  "tertiary": "#000000"
                },
                "text": {
                  "primary": "#FFF",
                  "secondary": "#C0C0C0",
                  "tertiary": "#999999"
                }
              }
            },
            "primaryToggle": {
              "normal": {
                "background": "#C0C0C0",
                "text": "#333333",
                "stroke": "#fff",
                "image": "#fff"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#fff",
                "image": "#fff"
              }
            },
            "secondaryToggle": {
              "normal": {
                "background": "#C0C0C0",
                "text": "#333333",
                "stroke": "#fff",
                "image": "#fff"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#fff",
                "image": "#fff"
              }
            },
            "primaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "focussed": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              }
            },
            "secondaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "focussed": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "tertiaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "sliderIndicator": {
              "normal": {
                "background": "rgba(115, 115, 115, 1)",
                "text": "#333333",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(255, 232, 41, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "disabled": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              }
            },
            "selectorStyle": {
              "normal": {
                "background": "#f7f72a",
                "text": "#333333",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "dropdownStyle": {
              "normal": {
                "background": "rgba(34, 34, 34, 1)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(68, 68, 68, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "toastTheme": {
              "accent": {
                "primary": "rgba(255, 228, 0, 1)",
                "secondary": "#f7f72a",
                "tertiary": "#4d4d4d",
                "error": null
              },
              "background": {
                "primary": "rgba(43, 43, 43, 1)",
                "secondary": "#000",
                "tertiary": "#000",
                "error": null
              },
              "text": {
                "primary": "rgba(255, 255, 255, 1)",
                "secondary": "rgba(255, 228, 0, 1)",
                "tertiary": "#4d4d4d",
                "error": null
              },
              "curvedEdges": true
            }
          },
          "graphics": [
            {
              "id": "app_header_logo",
              "anchor": "center",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/app_header_logo.png",
                  "orientation": null
                }
              ]
            },
            {
              "id": "app_splash",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/splash_web.png",
                  "orientation": "landscape"
                }
              ]
            },
            {
              "id": "app_popup_logo",
              "anchor": "center",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/app_header_logo.png",
                  "orientation": null
                }
              ]
            }
          ]
        },
        "images": [
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_2048x1152_16294981697.jpg",
            "type": "landscape",
            "width": 2048,
            "height": 1152
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_828x464_16294981698.jpg",
            "type": "landscape",
            "width": 828,
            "height": 464
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_760x428_16294981699.jpg",
            "type": "landscape",
            "width": 760,
            "height": 428
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_526x296_16294981700.jpg",
            "type": "landscape",
            "width": 526,
            "height": 296
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_1280x720_15921221815.jpg",
            "type": "landscape",
            "width": 1280,
            "height": 720
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_large.jpg",
            "type": "square",
            "width": 1080,
            "height": 1080
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_medium.jpg",
            "type": "square",
            "width": 640,
            "height": 640
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_small.jpg",
            "type": "square",
            "width": 360,
            "height": 360
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_2_3_small.jpg",
            "type": "portrait",
            "width": 210,
            "height": 315
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_large.jpg",
            "type": "landscape",
            "width": 1440,
            "height": 1080
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_medium.jpg",
            "type": "landscape",
            "width": 700,
            "height": 525
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_small.jpg",
            "type": "landscape",
            "width": 300,
            "height": 225
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_large.jpg",
            "type": "landscape",
            "width": 1500,
            "height": 570
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_medium.jpg",
            "type": "landscape",
            "width": 700,
            "height": 226
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_small.jpg",
            "type": "landscape",
            "width": 480,
            "height": 182
          }
        ],
        "metaTheme": {
          "header": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(0, 0, 0, 1)",
              "secondary": "rgba(0, 0, 0, 1)",
              "tertiary": "rgba(0, 0, 0, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(166, 166, 166, 1)",
              "error": null
            },
            "curvedEdges": true
          },
          "body": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 228, 0, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(43, 43, 43, 1)",
              "secondary": "rgba(0, 0, 0, 1)",
              "tertiary": "rgba(146, 146, 146, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(166, 166, 166, 1)",
              "tertiary": "rgba(255, 255, 255, 1)",
              "error": null
            }
          },
          "footer": {
            "accent": {
              "primary": "rgba(255, 228, 0, 1)",
              "secondary": "rgba(255, 255, 255, 1)",
              "tertiary": "rgba(115, 115, 115, 1)",
              "error": null
            },
            "background": {
              "primary": "rgba(0, 0, 0, 1)",
              "secondary": "rgba(115, 115, 115, 1)",
              "tertiary": "rgba(43, 43, 43, 1)",
              "error": null
            },
            "text": {
              "primary": "rgba(255, 255, 255, 1)",
              "secondary": "rgba(255, 255, 255, 1)",
              "tertiary": "rgba(222, 222, 222, 1)",
              "error": null
            }
          },
          "compositeStyle": {
            "calendarStyle": {
              "body": {
                "accent": {
                  "primary": "#f7f72a",
                  "secondary": "#FFF",
                  "tertiary": "#4d4d4d"
                },
                "background": {
                  "primary": "#f7f72a",
                  "secondary": "#333333",
                  "tertiary": "#000000"
                },
                "text": {
                  "primary": "#FFF",
                  "secondary": "#C0C0C0",
                  "tertiary": "#999999"
                }
              }
            },
            "primaryToggle": {
              "normal": {
                "background": "#C0C0C0",
                "text": "#333333",
                "stroke": "#fff",
                "image": "#fff"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#fff",
                "image": "#fff"
              }
            },
            "secondaryToggle": {
              "normal": {
                "background": "#C0C0C0",
                "text": "#333333",
                "stroke": "#fff",
                "image": "#fff"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#fff",
                "image": "#fff"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#fff",
                "image": "#fff"
              }
            },
            "primaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(0, 0, 0, 0)"
              },
              "focussed": {
                "background": "rgba(255, 232, 41, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              }
            },
            "secondaryButton": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "focussed": {
                "background": "rgba(255, 232, 41, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "tertiaryButton": {
              "normal": {
                "background": "#f7f72a",
                "text": "#333333",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "#f7f72a",
                "text": "#fff",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "#222222",
                "text": "#fff",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "sliderIndicator": {
              "normal": {
                "background": "rgba(115, 115, 115, 1)",
                "text": "#333333",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(255, 232, 41, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              },
              "disabled": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "rgba(255, 228, 0, 1)"
              }
            },
            "selectorStyle": {
              "normal": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(0, 0, 0, 0)",
                "text": "rgba(255, 228, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(29, 29, 29, 1)",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "dropdownStyle": {
              "normal": {
                "background": "rgba(34, 34, 34, 1)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "focussed": {
                "background": "rgba(68, 68, 68, 1)",
                "text": "rgba(0, 0, 0, 1)",
                "stroke": "#00000000"
              },
              "pressed": {
                "background": "rgba(222, 198, 0, 1)",
                "text": "#000",
                "stroke": "#00000000"
              },
              "selectedFocussed": {
                "background": "#f7f72a",
                "text": "#000",
                "stroke": "#fff",
                "image": "#fff"
              },
              "selected": {
                "background": "rgba(255, 228, 0, 1)",
                "text": "rgba(255, 255, 255, 1)",
                "stroke": "#f7f72a"
              },
              "disabled": {
                "background": "#00000000",
                "text": "#f7f72a",
                "stroke": "#f7f72a"
              }
            },
            "toastTheme": {
              "accent": {
                "primary": "rgba(255, 228, 0, 1)",
                "secondary": "#f7f72a",
                "tertiary": "#4d4d4d",
                "error": null
              },
              "background": {
                "primary": "rgba(43, 43, 43, 1)",
                "secondary": "#000",
                "tertiary": "#000",
                "error": null
              },
              "text": {
                "primary": "rgba(255, 255, 255, 1)",
                "secondary": "rgba(255, 228, 0, 1)",
                "tertiary": "#4d4d4d",
                "error": null
              },
              "curvedEdges": true
            }
          },
          "graphics": [
            {
              "id": "app_header_logo",
              "anchor": "center",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/app_header_logo.png",
                  "orientation": null
                }
              ]
            },
            {
              "id": "app_splash",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/splash_web.png",
                  "orientation": "landscape"
                }
              ]
            },
            {
              "id": "app_popup_logo",
              "anchor": "center",
              "images": [
                {
                  "url": "https://diagnal-apps.s3.amazonaws.com/create/images/logos/app_header_logo.png",
                  "orientation": null
                }
              ]
            }
          ]
        },
        "baseUrl": "https://api-comcast.create.diagnal.com",
        "progress": 0,
        "isCcAvailable": false,
        "parentalControl": [
          {}
        ],
        "displayDuration": null,
        "contentGuid": "FQ5Wd1wjZFy39eve9RWp23HrHjSAaGfc",
        "purchaseMode": "free",
        "percentComplete": 100,
        "isProductLoading": false,
        "streams": "https://link.theplatform.com/s/tzTJhC/media/ad_yEfI0NVSl",
        "smilUrl": "https://link.theplatform.com/s/tzTJhC/media/ad_yEfI0NVSl",
        "episodeNum": "",
        "thumbnailImgs": [
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_2048x1152_16294981697.jpg",
            "type": "landscape",
            "width": 2048,
            "height": 1152
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_828x464_16294981698.jpg",
            "type": "landscape",
            "width": 828,
            "height": 464
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_760x428_16294981699.jpg",
            "type": "landscape",
            "width": 760,
            "height": 428
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_526x296_16294981700.jpg",
            "type": "landscape",
            "width": 526,
            "height": 296
          },
          {
            "url": "https://pmd205470tn-a.akamaihd.net/D2C_-_Content/847/701/Relativity_15921221710_mp4_video_1920x1080_8000000_all_audio_8_1280x720_15921221815.jpg",
            "type": "landscape",
            "width": 1280,
            "height": 720
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_large.jpg",
            "type": "square",
            "width": 1080,
            "height": 1080
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_medium.jpg",
            "type": "square",
            "width": 640,
            "height": 640
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_1_1_small.jpg",
            "type": "square",
            "width": 360,
            "height": 360
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_2_3_small.jpg",
            "type": "portrait",
            "width": 210,
            "height": 315
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_large.jpg",
            "type": "landscape",
            "width": 1440,
            "height": 1080
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_medium.jpg",
            "type": "landscape",
            "width": 700,
            "height": 525
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_4_3_small.jpg",
            "type": "landscape",
            "width": 300,
            "height": 225
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_large.jpg",
            "type": "landscape",
            "width": 1500,
            "height": 570
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_medium.jpg",
            "type": "landscape",
            "width": 700,
            "height": 226
          },
          {
            "url": "https://create-static.s3-ap-southeast-1.amazonaws.com/images/placeholders/image_50_19_small.jpg",
            "type": "landscape",
            "width": 480,
            "height": 182
          }
        ]
      }
    }
    history.push(`${routeMap.player}?mediaId=277046310581&progress=0&duration=null`, state)

  }
  /* --------------------------------------------- */
  /**
   * It: Sets progress.
   */
  useEffect(() => {
    const progress = progressProp || 0
    const maxResumePercent = playerFeature.maxResumePercent || 100
    const currentPerc = (progress * 100) / durationProp
    if (currentPerc >= maxResumePercent) {
      setProgress(0)
    } else {
      setProgress(progress)
    }
  }, [progressProp, durationProp, playerFeature.maxResumePercent])
  /* --------------------------------------------- */
  return (
    <div style={{ flexShrink: 0 }}>
      {isShowWaringPopup && <WarningPopup {...{ WarningClickHandle }} />}
      <DetailsSectionWrapper {...{ theme }} className='details-section-container'>
        {/* Portrait Player */}
        <div className='details-section-player'>
          <PlayerContainer
            ref={playerRef} {...{
              onPlayClick,
              onErrorOkClick: resetPlayer,
              thisIsChannel,
              mediaInfo: {
                smilUrl: playerUrl,
                title,
                subTitle,
                isLivePlayer,
                thumbnailImgs: currentPosterImage,
                mediaId,
                seasonId,
                type,
                baseUrl,
                curentSeason,
                isSportingEvent,
                isOnNow: isLive,
                activeSeasonNumber: activeSeason?.seasonNumber,
                isPurchasedProduct,
              },
              catalogTheme: theme

            }}
          />
        </div>

        {/* Season Selector Popup */}
        {type && type === 'series' && isSeasonPopup &&
          <div className={`details-page__pop-up season-selector ${isSeasonPopup ? 'details-page__pop-up---open' : ''}`}>
            <DetailsPopup theme={metaTheme} className='details-page__pop-up-wrapper'>
              <div className='details-page__pop-up-head'>
                <div className='title-wrapper'>
                  <DetailsPagePopupHeader {...{ metaTheme }}>{title}</DetailsPagePopupHeader>
                </div>
                <div className='player-audio__close' onClick={seasonChooserHandle}>
                  <CloseIcon color={metaTheme && metaTheme.header && metaTheme.header.accent.primary} style={{ width: 19, height: 19 }} />
                </div>
              </div>
              <SeasonSelector {...{ metaTheme }} className='details-page__pop-up-content'>
                <ul className='details-page__pop-up-content-season-list'>
                  {seasonData && seasonData.map(({ seasonNumber }, index) => {
                    return <li className={`${activeSeason?.seasonNumber === seasonNumber ? 'active' : ''}`} onClick={(e) => seasonListHandler(e, index)} key={index}><h3>{appMessages.label_details_season} {seasonNumber}</h3></li>
                  })}
                </ul>
              </SeasonSelector>
            </DetailsPopup>
          </div>}

        {/* Share Popup */}
        {sharePopUp && <div className={`details-page__pop-up season-selector sharePopUp ${sharePopUp ? 'details-page__pop-up---open' : ''}`}>
          <DetailsPopup theme={metaTheme} ref={sharePopupRef} className='details-page__pop-up-wrapper'>
            <div className='details-page__pop-up-head'>
              <div>
                <BodyTextSecondary {...{ metaTheme }}>{appMessages.label_details_share}</BodyTextSecondary>
                <h1> {title} </h1>
              </div>
              <div className='player-audio__close' onClick={shareOnclickHandle}>
                <CloseIcon color={metaTheme && metaTheme.header && metaTheme.header.accent.primary} style={{ width: 18, height: 18 }} />
              </div>
            </div>
            <div className='sharePopUp__content'>
              <div className='single facebook'>
                <FacebookShareButton url={shareUrl}>
                  <FacebookIcon size={32} round />
                  <p>Facebook</p>
                </FacebookShareButton>
              </div>
              <div className='single twitter'>
                <TwitterShareButton url={shareUrl}>
                <TwitterIcon color={"#FFF"} size={20} round withPadding/>
                  <p>Twitter</p>
                </TwitterShareButton>
              </div>
              <div className='single normal' onClick={copyLinkHandle}>
                <p className='copy_link'>{appMessages.label_details_copy_link}</p>
              </div>
            </div>
          </DetailsPopup>
        </div>}

        {/* More Info Popup */}
        {params.type !== routeVarMap.type.sports && params.type !== routeVarMap.type.match && isMediaDeatilsPopup &&
          <div className={`details-page__pop-up details-page__pop-up---media ${isMediaDeatilsPopup ? 'details-page__pop-up---open' : ''}`}>
            <DetailsPopup theme={metaTheme} ref={mediaPopupRef} className='details-page__pop-up-wrapper'>
              <div className='details-page__pop-up-head'>
                <div>
                  {type && type === 'series' && <BodyTextSecondary {...{ metaTheme }} className='episode-data'>{title}</BodyTextSecondary>}
                  <DetailsPagePopupHeader {...{ metaTheme }}>{(type && type === 'series') ? `${appMessages.label_details_season} ${(activeSeason && activeSeason?.seasonNumber) || ''}` : title}</DetailsPagePopupHeader>
                </div>
                <div className='player-audio__close' onClick={moreInfoHandler}>
                  <CloseIcon color={theme && theme.body && theme.body.accent.primary} style={{ width: 18, height: 18 }} />
                </div>
              </div>
              <div className='details-section-header__badges'>
                <DetailsPageBadges {...{ metaTheme }}>
                  {type && type !== 'series' ?
                    ((duration || releaseYear) && <p>{duration && <span className='duration'>{duration}</span>}{releaseYear && <span className='releaseYear'>{releaseYear}</span>}</p>)
                    :
                    <>{activeSeason && activeSeason.releaseYear && <p><span className='releaseYear'>{activeSeason.releaseYear}</span> </p>}</>
                  }
                  {((parentalControl && parentalControl[0] && parentalControl[0].rating) || (activeSeason && activeSeason.parentalControl && activeSeason.parentalControl[0] && activeSeason.parentalControl[0].rating) || isCcAvailable || (activeSeason && activeSeason.isCcAvailable) || isHdAvailable || (activeSeason && activeSeason.isHdAvailable)) ? <div>
                    {(type && type === 'series' && activeSeason) ? activeSeason.parentalControl && activeSeason.parentalControl[0] && activeSeason.parentalControl[0].rating && <li className='filled'>{activeSeason.parentalControl[0].rating}</li> : parentalControl && parentalControl[0] && parentalControl[0].rating && <li className='filled'>{parentalControl[0].rating}</li>}
                    {(type && type === 'series' && activeSeason) ? activeSeason.isCcAvailable && <li className='hollow'>{appMessages.label_details_cc}</li> : isCcAvailable && <li className='hollow'>{appMessages.label_details_cc}</li>}
                    {isHdAvailable && <li className='hollow'>{appMessages.label_details_hd}</li>}
                  </div> : null}
                </DetailsPageBadges>
              </div>
              <div className='details-page__pop-up-content'>
                <MetaBodyTextTertiaryP {...{ metaTheme }} className='description'>{type && type === 'series' ? descriptionData : description}</MetaBodyTextTertiaryP>
                <div className='details-section-details'>
                  {(type && type === 'series' && activeSeason?.numberOfEpisodes) ?
                    <div className='details-section-details-row'>
                      <MetaBodyTextSecondary {...{ metaTheme }} className='details-section-details-title'>{appMessages.label_details_episodes}</MetaBodyTextSecondary>
                      <MetaBodyTextTertiary {...{ metaTheme }} className='details-section-details-description'>{activeSeason?.numberOfEpisodes}</MetaBodyTextTertiary>
                    </div> : null}
                  {
                    ((type === 'series' ? activeSeason?.details : details) || []).map(({ key, label, value }, i) => {
                      if (!value) return null
                      return (
                        <div key={i} className='details-section-details-row'>
                          <MetaBodyTextSecondary {...{ metaTheme }} className='details-section-details-title'>
                            {label}
                          </MetaBodyTextSecondary>
                          <MetaBodyTextTertiary {...{ metaTheme }} className='details-section-details-description'>
                            {value && value.map(({ title }, i) => {
                              if (key === 'availableTill' || key === 'countries') {
                                return (
                                  <span key={i}>{title}
                                    {value.length - 1 === i ? '' : ', '}
                                  </span>
                                )
                              } else {
                                return (
                                  <Link key={i} to={`${routeMap.listing}?search=${title}&mode=${key.toLowerCase()}`}
                                    onClick={moreInfoHandler}>{title}
                                    {value.length - 1 === i ? '' : ', '}
                                  </Link>
                                )
                              }
                            })}
                          </MetaBodyTextTertiary>
                        </div>
                      )
                    }).filter((res) => res)
                  }
                  {/* <div details-section='details-section__rating'>
                  <div className='details-section-details-row'>
                    <DetailsSectionMetaTitle {...{ theme }} className='details-section-details-title'>Ratings</DetailsSectionMetaTitle>
                    <div className='imdb-rating-widget'>
                      <img src={imdbLogo} alt='' />
                      <DetailsSectionMetaValue {...{ theme }} className='details-section-details-description'>8 / 10</DetailsSectionMetaValue>
                      <StarFilledIcon color='#fff' style={{ width: 12, height: 12 }} />
                    </div>
                  </div>
                </div> */}
                </div>
              </div>
            </DetailsPopup>
          </div>}
        {/* Details section */}
        <div className='details-section'>
          {!dataLoading ? (params.type === routeVarMap.type.sports || params.type === routeVarMap.type.sportingevent || params.type === routeVarMap.type.sportingEvent || params.type === routeVarMap.type.match || params.type === routeVarMap.type.channel)
            ? (
              <div className='details-section__sports'>
                <div className='details-section__sports-content'>
                  <div className='details-section-header'>
                    {isThisCREATE && <img alt="" src={images && images[0] && images[0].url && images[0].url} className="details-section-header__channel-logo" />}
                    <DetailsSectionSubtitle {...{ metaTheme }} className='detailsSection__subtitle'>{subTitle}</DetailsSectionSubtitle>
                    <DetailsSectionTitle {...{ metaTheme }} className='detailsSection__title'>{title}</DetailsSectionTitle>
                    {isShowFavourites &&
                      <div className='details-section-favourites'>
                        <FavouritesIcon />
                      </div>}
                  </div>
                  <div className='details-section-body' style={{ borderBottom: '3px solid #333' }}>
                    {timeLeft > 0 &&
                      <div className='details-section-timer'>
                        <Timer {...{ timeLeft, metaTheme, resetPlayer }} />
                      </div>}
                    <div className='details-section-details'>
                      {details.map(({ key, label, value }, i) => {
                        if (!value) return null
                        return (
                          <div key={i} className='details-section-details-row'>
                            <DetailsSectionMetaTitle {...{ theme }} className='details-section-details-title'>
                              {label}
                            </DetailsSectionMetaTitle>
                            <DetailsSectionMetaValue {...{ theme }} className='details-section-details-description'>
                              {value && value.map(({ title, link }, i) => {
                                if (!link) return title
                                return (
                                  <Link key={i} to={link}>{title}
                                    {value.length - 1 === i ? '' : ', '}
                                  </Link>)
                              })}
                            </DetailsSectionMetaValue>
                          </div>
                        )
                      }).filter((res) => res)}
                    </div>
                    <DetailsSectionDescription {...{ theme }} className='details-section-overview-container'>
                      {/* <div className="details-section-overview-title">Overview</div> */}
                      <div>{description}</div>
                    </DetailsSectionDescription>
                    {title && isThisCREATE && <div className="details-section__play-button" onClick={playLiveChannelInPlayer}>
                      Watch Now
                    </div>}
                  </div>
                </div>
              </div>
            )
            : (
              <div className='details-section__media'>
                {/* <div className='details-section__oveflow' /> */}
                <div className='details-section__media-content'>
                  <div className='details-section-header'>
                    <div className='details-section-header__content'>
                      <DetailsSectionTitle {...{ metaTheme }} className='detailsSection__title'>{title}</DetailsSectionTitle>
                      {subTitle && <DetailsSectionSubtitleMovie {...{ metaTheme }} className='detailsSection__subtitle'>{appMessages.label_details_subtitle_prefix} {subTitle}</DetailsSectionSubtitleMovie>}
                      <div className='details-section-header__badges'>
                        <DetailsPageBadges {...{ metaTheme }}>
                          {type && type !== 'series' ?
                            ((duration || releaseYear) && <p>{duration && <span className='duration'>{duration}</span>}{releaseYear && <span className='releaseYear'>{releaseYear}</span>}</p>)
                            :
                            <>{activeSeason && activeSeason.releaseYear && <p><span className='releaseYear'>{activeSeason.releaseYear}</span> </p>}</>
                          }
                          {((parentalControl && parentalControl[0] && parentalControl[0].rating) || (activeSeason && activeSeason.parentalControl && activeSeason.parentalControl[0] && activeSeason.parentalControl[0].rating) || isCcAvailable || (activeSeason && activeSeason.isCcAvailable) || isHdAvailable || (activeSeason && activeSeason.isHdAvailable)) ? <div>
                            {(type && type === 'series' && activeSeason) ? activeSeason.parentalControl && activeSeason.parentalControl[0] && activeSeason.parentalControl[0].rating && <li className='filled'>{activeSeason.parentalControl[0].rating}</li> : parentalControl && parentalControl[0] && parentalControl[0].rating && <li className='filled'>{parentalControl[0].rating}</li>}
                            {(type && type === 'series' && activeSeason) ? activeSeason.isCcAvailable && <li className='hollow'>{appMessages.label_details_cc}</li> : isCcAvailable && <li className='hollow'>{appMessages.label_details_cc}</li>}
                            {isHdAvailable && <li className='hollow'>{appMessages.label_details_hd}</li>}
                          </div> : null}
                        </DetailsPageBadges>
                      </div>
                    </div>
                    <div className='details-section-header__actions'>
                      {catalogFeature && catalogFeature.allowSharing &&
                        <div className='action__single'>
                          <ShareOutlineIcon onClick={shareOnclickHandle} color={theme && theme.body && theme.body.accent.primary} style={{ width: 22, height: 22 }} />
                          <input type='hidden' id='input-url' value='' />
                        </div>}
                      {catalogFeature && catalogFeature.allowFavoriting && isAuthenticated &&
                        <div className='action__single'>
                          {isShowFavouriteIcon
                            ? (
                              <>
                                {isFavourite && !isFavouriteRunning && <FavMarkedIcon onClick={favOnClickHandler} color={theme && theme.body && theme.body.accent.primary} style={{ width: 22, height: 22 }} />}
                                {!isFavourite && !isFavouriteRunning && <FavOutlineIcon onClick={favOnClickHandler} color={theme && theme.body && theme.body.accent.primary} style={{ width: 22, height: 22 }} />}
                                {isFavouriteRunning && <div className='favourite-processing'><FavOutlineIcon color={theme && theme.body && theme.body.accent.primary} style={{ width: 22, height: 22 }} /></div>}
                              </>
                            )
                            : <Spinner size={22} IsLoading />}
                        </div>}
                    </div>
                  </div>
                  {(url || (trailers && trailers.length > 0)) &&
                    <div className='details-section-btn__action'>
                      {url && mediaId && catalogFeature && catalogFeature.showPlayAction && type !== 'preview' && Object.keys(appMessages).length > 0 &&
                        (type !== 'series' || (seasonData.length > 0 && seasonNumber && episodeNumber)) &&
                        <PlayBtnAction {...{ theme }} className='action__single' onClick={isCastConnectedStatus && isAuthenticated ? castHandlePlayClick : handlePlayClick}>
                          <PlayOutlineIcon color={theme && theme.compositeStyle &&
                            theme.compositeStyle.primaryButton.normal.text
                          } style={{ width: 15, height: 15 }} className='normal' />
                          <PlayOutlineIcon color={theme && theme.compositeStyle &&
                            theme.compositeStyle.primaryButton.focussed.text} style={{ width: 15, height: 15 }} className='hover' />
                          {type && type === 'series' ? <p>{appMessages.label_details_season_prefix}{seasonNumber} {appMessages.label_details_episode_prefix}{episodeNumber}</p> : <p>{progress ? appMessages.label_details_resume : appMessages.label_details_play}</p>}
                        </PlayBtnAction>}
                      {((currentTrailer && catalogFeature && catalogFeature.showTrailers && Object.keys(appMessages).length > 0) || type === 'preview') &&
                        <PlayBtnAction {...{ theme }} className='action__single' onClick={isCastConnectedStatus && isAuthenticated ? (e) => castHandlePlayClick(e, true) : handleTrailerPlayClick}>
                          <PlayOutlineIcon color={theme && theme.compositeStyle &&
                            theme.compositeStyle.primaryButton.normal.text
                          } style={{ width: 15, height: 15 }} className='normal' />
                          <PlayOutlineIcon
                            color={theme && theme.compositeStyle &&
                              theme.compositeStyle.primaryButton.focussed.text}
                            style={{ width: 15, height: 15 }} className='hover' />
                          <p>{appMessages.label_details_play_trailer}</p>
                        </PlayBtnAction>}
                    </div>}
                  <div className='details-section-body'>
                    {(type === 'series' && seasonData.length) ?
                      <div className='details-section-body__header'>
                        <MetaBodyTextPrimaryH2 {...{ metaTheme }} style={{ cursor: seasonData.length > 1 ? 'pointer' : 'default' }} onClick={seasonData.length > 1 ? seasonChooserHandle : null}>{appMessages.label_details_season} {activeSeason && activeSeason.seasonNumber} {seasonData.length > 1 ? <DropDownCircle color={theme && theme.body && theme.body.accent.primary} style={{ width: 22, height: 22 }} /> : null} </MetaBodyTextPrimaryH2>
                      </div> :null}
                    <MetaBodyTextTertiaryP {...{ metaTheme }} className='description'>{type && type === 'series' ? descriptionData : description}</MetaBodyTextTertiaryP>
                    {(activeSeason?.numberOfEpisodes || ((type === 'series' ? activeSeason?.details : details) || []).length > 0) &&
                      <h3 className='details-section__more-info-link' onClick={moreInfoHandler}>{appMessages.label_details_more_info}</h3>
                    }
                  </div>
                </div>
              </div>
            )
            : (
              <div className='details-section___skeleton-wrapper'>
                <SkeletonTheme color={theme?.body?.background?.tertiary} highlightColor='#969696'>
                  <Skeleton height={30} width='85%' duration={2} />
                  <p>
                    <Skeleton height={15} width='50%' duration={2} />
                  </p>
                  <Skeleton height={15} width='25%' duration={2} />
                  <div className='play'>
                    <Skeleton height={43} width={100} duration={2} />
                  </div>
                </SkeletonTheme>
              </div>
            )}
        </div>
      </DetailsSectionWrapper>
      <SEOTags jsonLD={{ ...jsonLD, imagesArr: currentPosterImage }} />
    </div>
  )
}


/* --------------------------------------------- */
DetailsSection.propTypes = {
  /** URL passed to the player. */
  url: PropTypes.string,
  /** Main title shown in details section & in player. */
  title: PropTypes.string,
  /** Breadcrumb shown in details section & in player. */
  subtitle: PropTypes.string,
  /** Metadata shown in details section. */
  details: PropTypes.array,
  /** Description shown in details section. */
  description: PropTypes.string,
  /** UTC time label (eg. timer or 'On Now' text) shown in details section. */
  timeLeft: PropTypes.number,
  /** Boolean to show/hide favourite icon. */
  isShowFavourites: PropTypes.bool,
  /** Boolean to identify sporting event. */
  isSportingEvent: PropTypes.bool,
  /** Boolean to show/hide parental rating & star rating. */
  isShowRating: PropTypes.bool,
  /** Theme object used to style component. */
  theme: PropTypes.object,
  /** Placeholder image shown in the place of player. */
  images: PropTypes.array
}
/* --------------------------------------------- */
DetailsSection.defaultProps = {
  jsonLD: '',
  url: '',
  title: '',
  subtitle: '',
  details: [],
  description: '',
  timeLeft: 0,
  isShowFavourites: false,
  isSportingEvent: false,
  isShowRating: false,
  theme: {},
  images: []
}
/* --------------------------------------------- */
export default DetailsSection
  /* --------------------------------------------- */
